module.exports = __webpack_public_path__ + "officialStatic/img/tkb.e765631.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/tkb.png
// module id = VFmr
// module chunks = 0